import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksDesktopInstanceConstructor,
  QuickBooksDesktopInstance,
} from './QuickBooksDesktopInstance'

export const QuickBooksDesktopInstanceConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksDesktopInstanceConstructor>({
    id: Factory.each(() => faker.random.number()),
    url: 'C:\\QuickBooks\\company-file.qbw',
  })

export const QuickBooksDesktopInstanceFactory = EntityFactory(
  QuickBooksDesktopInstance,
  QuickBooksDesktopInstanceConstructorFactory
)
